import React from 'react';
import PropTypes from 'prop-types';

const Stop = ({ fill, theme, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 1.12C9.84814 1.12 7.7446 1.7581 5.9554 2.95361C4.16619 4.14912 2.77167 5.84834 1.94819 7.8364C1.12471 9.82446 0.909249 12.0121 1.32906 14.1226C1.74886 16.2331 2.78508 18.1717 4.30668 19.6933C5.82827 21.2149 7.7669 22.2511 9.87742 22.6709C11.9879 23.0907 14.1755 22.8753 16.1636 22.0518C18.1517 21.2283 19.8509 19.8338 21.0464 18.0446C22.2419 16.2554 22.88 14.1519 22.88 12C22.88 9.11444 21.7337 6.34707 19.6933 4.30667C17.6529 2.26628 14.8856 1.12 12 1.12ZM12 20.7C10.3767 20.6983 8.78627 20.242 7.40902 19.3827C6.03177 18.5234 4.92274 17.2955 4.20762 15.8382C3.49249 14.3809 3.19986 12.7524 3.36288 11.1373C3.52591 9.52218 4.13807 7.98501 5.13 6.7L17.33 18.9C15.8046 20.0792 13.928 20.713 12 20.7ZM18.87 17.33L6.67 5.13C8.34145 3.82034 10.4346 3.16799 12.5541 3.29614C14.6737 3.42428 16.673 4.32405 18.1745 5.82554C19.6759 7.32703 20.5757 9.32631 20.7039 11.4459C20.832 13.5654 20.1797 15.6585 18.87 17.33Z"
      fill={fill || theme.COLORS.danger}
    />
  </svg>
);

Stop.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Stop;
